// common use: prevent event bubble from action in popper
const handleEventBlock = event => {
  event.nativeEvent.stopImmediatePropagation();
  event.stopPropagation();
  event.preventDefault();
};

export default handleEventBlock;
